import { Component } from '@angular/core';
import { BaseComponent } from '../component-base';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html'
})
export class LanguageSwitcherComponent extends BaseComponent {
  public selectedLanguage!: string;

  constructor() {
    super();
    this.selectedLanguage = this.translate.currentLang;
  }

  setLanguage(language: string): void {
    localStorage.setItem('lang', language);
    this.selectedLanguage = this.translate.currentLang;
    this.translate.set("lang", language);
    window.location.reload();
  }

}
